// 模块的store
import Vue from 'vue';
import Vuex, {StoreOptions} from 'vuex';
import {HomeState} from '@/module/home/store/home-state';
import {Actions} from '@/module/home/store/actions';
import {Getters} from '@/module/home/store/getters';
import {Mutations} from '@/module/home/store/mutations';


Vue.use(Vuex);
// 开发环境启用严格模式
const debug = process.env.NODE_ENV !== 'production';

const Store = new Vuex.Store({
  strict: debug,
  state: <HomeState>{},
  actions: Actions,
  getters: Getters,
  mutations: Mutations,
  modules: {
    moduleInfra: window.XinInfra.xinInfraStore
  },
});
export default Store;
